import { useFormikContext } from 'formik';
import { useCallback } from 'react';
import { BirthdayPicker, FormLabel, Select, SelectOption } from 'ui-components';
import {
  ILocation,
  SearchLocation,
} from '~/screens/MyAgency/components/SearchLocation';

import { ProfileFormValues } from './types';

export const ProfileLocationGenderDob: React.FC = () => {
  const { values, setFieldValue, setErrors, errors } =
    useFormikContext<ProfileFormValues>();

  const onChangeLocation = useCallback(
    (location: ILocation) => {
      setFieldValue('location', location);
    },
    [setFieldValue],
  );

  const onLocationError = useCallback(
    (error?: boolean) => {
      if (error) {
        setErrors({ ...errors, location: 'Invalid location' });
      } else {
        // Clear location error if no error
        const { location, ...restErrors } = errors;
        setErrors(restErrors);
      }
    },
    [errors, setErrors],
  );

  return (
    <div className="flex items-start gap-6">
      <div className="flex-1">
        <div>
          <FormLabel>Location</FormLabel>
          <SearchLocation
            values={values.location}
            setValues={onChangeLocation}
            onError={onLocationError}
            trackId="foam-profile-settings--location"
            inputProps={{
              clearButtonProps: {
                'aria-label': 'Clear location',
                'track-id': 'foam-profile-settings--location-clear',
              },
            }}
          />
        </div>
      </div>

      <div className="flex flex-1 flex-col gap-1">
        <FormLabel>Gender</FormLabel>

        <Select
          placeholder="Select"
          value={values.gender}
          onChange={(opt) => setFieldValue('gender', opt.value)}
          showPlaceholder
          margin={0}
          data-testid="creator-profile-gender"
          trackId="foam-profile-settings--gender"
        >
          <SelectOption value="Male">Male</SelectOption>
          <SelectOption value="Female">Female</SelectOption>
          <SelectOption value="Non Binary">Non Binary</SelectOption>
        </Select>
      </div>

      <div className="flex-1">
        <BirthdayPicker
          name="dateOfBirth"
          inputProps={{
            trackId: 'foam-profile-settings--date-of-birth',
            clearButtonProps: {
              'aria-label': 'Clear date of birth',
              trackId: 'foam-profile-settings--date-of-birth-clear',
            },
          }}
        />
      </div>
    </div>
  );
};
